import React from 'react'
import { Accordion, Container, Icon } from 'semantic-ui-react'
import styled from 'styled-components'
import wrapCategory from 'components/categories/wrapCategory'
import { pink, lightRed } from 'theme.js'
import { Link } from 'react-router-dom'

const Wrapper = styled.div`
  a {
    display: block;
  }

  .title {
    &:hover {
      color: white !important;
      background: ${pink};
    }

    &.active {
      color: white !important;
      background: ${pink};
    }
  }

  .content {
    &.active {
      background: ${lightRed};
    }
  }
`

const FlatsListing = ({ id }) => {
  return (
    <Wrapper>
      <Accordion.Title as={Link} to={`/${id}/flats`}>
        <Container className="category-title">
          квартиры
          <Icon name="external" />
        </Container>
      </Accordion.Title>
    </Wrapper>
  )
}

export default wrapCategory(FlatsListing)
